import React, { Component, Fragment } from "react";

import "./AutoCompleteExtension.css";

export const CHAT_AUTOCOMPLETE_EXT_ID = "CHAT_AUTOCOMPLETE";

export default class AutoCompleteExtension extends Component {
  constructor(props) {
    super();

    this.state = {
      searchTerm: "",
      bottomMargin: 0,
      filteredSuggestions: [],
      maximised: false,
    };

    this.onSuggestionClicked.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.inputRegionElement = null;

    // Track input region height continuously so suggestions stay above a growing textbox.
    this.findInputTimerId = setInterval(() => {
      if (!this.inputRegionElement) {
        const chatbox = document.getElementById("chat_box");
        if (!chatbox) {
          return;
        }

        this.inputRegionElement = chatbox.querySelector("[role='form']");
        if (!this.inputRegionElement) {
          return;
        }

        this.updateSuggestions();
      }

      const nextBottomMargin = this.inputRegionElement.clientHeight || 0;
      if (nextBottomMargin !== this.state.bottomMargin) {
        this.setState({
          bottomMargin: nextBottomMargin,
        });
      }
    }, 120);
  }

  componentDidUpdate(oldProps) {
    if (!this.props.suggestions) {
      return;
    }

    if (oldProps.suggestions !== this.props.suggestions) {
      this.updateSuggestions();
    }
  }

  updateSuggestions() {
    this.setState({
      maximised: this.props.suggestions?.length > 0 ? true : false,
      filteredSuggestions: this.props.suggestions,
    });
  }

  onSuggestionClicked(suggestion) {
    this.props.api.sendActivity({
      type: "WEB_CHAT/SEND_MESSAGE",
      payload: { text: suggestion },
    });
    this.props.api.sendActivity({
      type: "WEB_CHAT/SET_SEND_BOX",
      payload: { text: "" },
    });
    this.setState({ maximised: !this.state.maximised });
  }

  handleDocumentClick(event) {
    const ignoreClickOnMeElement = document.getElementById("chat_box");
    if (!ignoreClickOnMeElement) {
      return;
    }

    if (this.state.maximised === true) {
      const isClickInsideElement = ignoreClickOnMeElement.contains(
        event.target,
      );
      if (isClickInsideElement) {
        this.setState({ maximised: false });
      }
    }
  }

  componentDidMount() {
    console.log(993, this.props.imagedomain);
    document.addEventListener("click", this.handleDocumentClick);
  }

  componentWillUnmount() {
    if (this.findInputTimerId) {
      clearInterval(this.findInputTimerId);
    }

    document.removeEventListener("click", this.handleDocumentClick);
  }

  render() {
    const color = this.props.styling;
    let imageLink = "https://bmbuiassetsprod.blob.core.windows.net";
    if (this.props.imagedomain) {
      imageLink = this.props.imagedomain;
    }

    // Keep suggestions above the input area and clamp values so the panel stays visible.
    const measuredInputHeight = this.state.bottomMargin || 48;
    const suggestionsBottom = Math.max(measuredInputHeight + 8, 61);
    const suggestionsMaxHeight = `min(52%, calc(100% - ${suggestionsBottom + 16}px))`;

    return (
      <Fragment>
        {this.state.maximised && this.state.filteredSuggestions.length > 0 ? (
          <Fragment>
            <div
              className="chat_auto_suggestion_container"
              style={{
                top: "auto",
                bottom: `${suggestionsBottom}px`,
                height: "auto",
                maxHeight: suggestionsMaxHeight,
              }}
            >
              <div className="chat_auto_suggestion_results">
                <div className="chat_auto_suggestion_header">
                  <div>
                    {" "}
                    <img src={`${imageLink}/images/minimizeresults.png`} />{" "}
                  </div>
                  <span> Suggestions </span>
                  <button
                    className="chat_auto_suggestion_header_hide"
                    style={{
                      borderColor: color.colours.header,
                    }}
                    onClick={() => {
                      this.setState({ maximised: !this.state.maximised });
                    }}
                  >
                    Hide
                  </button>
                </div>
                {this.state.filteredSuggestions.map((suggestion) => (
                  <div
                    className="chat_auto_suggestion_item"
                    key={suggestion.response}
                    onClick={() => {
                      this.onSuggestionClicked(suggestion.response);
                    }}
                  >
                    <div className="chat_auto_suggestion_item_inner">
                      <div
                        className="chat_auto_suggestion_item_select_box"
                        style={{
                          backgroundColor: color.colours.header,
                          border: `solid 1px ${color.colours.headerText}`,
                        }}
                      >
                        {" "}
                      </div>
                      <div className="chat_auto_suggestion_item_text">
                        {" "}
                        {suggestion.response}{" "}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div
              className="chat_auto_suggestion_header_minimise"
              style={{
                borderColor: color.colours.header,
                bottom: `${suggestionsBottom}px`,
              }}
            >
              {""}
            </div>
          </Fragment>
        ) : (
          ""
        )}
      </Fragment>
    );
  }
}
